import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Disclosure } from '@/components/molecules/Disclosure';
import type { CageBioscopeHistoryItem } from '@/domain/cages';
import { formatDayDisplay } from '@/utils/date';

interface BioscopeHistoryPopoverProps {
    history: CageBioscopeHistoryItem[];
}

export default function BioscopeHistoryPopover(props: BioscopeHistoryPopoverProps) {
    const { history } = props;
    const { t } = useTranslation();

    if (history.length === 0) {
        return <span>-</span>;
    }

    return (
        <Disclosure
            variant="inline"
            spacing="none"
            title={t('internal.cages.bioscopeHistory.count', { count: history.length })}>
            <ul>
                {history.map((historyItem) => (
                    <li key={historyItem.key}>
                        <Link to={`/internal/bioscopes/${historyItem.bioscopeId}`}>
                            {t('internal.cages.bioscopeHistory.bioscope', {
                                id: historyItem.bioscopeId,
                            })}
                        </Link>
                        : {formatDayDisplay(historyItem.from)} {'->'}{' '}
                        {historyItem.to
                            ? formatDayDisplay(historyItem.to)
                            : t('internal.cages.bioscopeHistory.current')}
                    </li>
                ))}
            </ul>
        </Disclosure>
    );
}
